export enum SignupJourneyAction {
  NewOfferer = 'NewOfferer',
  JoinModal = 'JoinModal',
  WaitingLinkButton = 'WaitingLinkButton',
  LinkModalActionButton = 'LinkModalActionButton',
}
